import CustomDaySelector from '../../../../../components/CustomDaySelector';
import CustomTimePicker from '../../../../../components/CustomTimePicker';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const ActiveScheduleStep = ({
    item,
    t,
    handleChange,
    emptyFields,
    dayArray,
    setDayArray,
    setItem,
    disabled,
    isCloseTimeInvalid,
    isEqualTimes,
    formatValue
}) => {

    return (
        <div className={"row mt-5"}>
            <div className='col-12 d-flex justify-content-center px-0 input-padding-bottom'>
                <CustomDaySelector
                    id='cb_ass_day_selector'
                    dayArray={dayArray}
                    setDayArray={setDayArray}
                    required={true}
                    emptyFields={emptyFields}
                    readonly={disabled}
                />
            </div>
            <div className='col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                <CustomTimePicker
                    title={t('from')}
                    name='opening'
                    value={item.opening}
                    handleChange={(value) => {
                        handleChange({ target: { name: 'opening', value: value } });
                    }}
                    required={true}
                    inputFormat='HH:mm:ss'
                    id='tp_ass_from'
                    views={['hours', 'minutes']}
                    emptyFields={emptyFields}
                    formatValue={formatValue}
                    disabled={disabled}
                />
            </div>

            <div className='col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                <CustomTimePicker
                    title={t('to')}
                    name='closing'
                    value={item.closing}
                    handleChange={(value) => handleChange({ target: { name: 'closing', value: value } })}
                    disabled={disabled || !item.opening}
                    required={true}
                    inputFormat='HH:mm:ss'
                    id='tp_ass_to'
                    views={['hours', 'minutes']}
                    formatValue={formatValue}
                    emptyFields={emptyFields}
                    minTime={item.opening}
                    isValid={!isCloseTimeInvalid && !isEqualTimes}
                    isValidText={
                        isEqualTimes
                            ? 'start_end_cannot_be_equal'
                            : isCloseTimeInvalid
                              ? 'end_date_cannot_be_before_start_date'
                              : ''
                    }
                />
            </div>
        </div>
    );
};

export default ActiveScheduleStep;
